module.exports = __webpack_public_path__ + "img/cosmotebooks.7fb99545.jpg";